import { render, staticRenderFns } from "./ModalEditTeamUserRole.vue?vue&type=template&id=7e480b17&scoped=true"
import script from "./ModalEditTeamUserRole.vue?vue&type=script&lang=js"
export * from "./ModalEditTeamUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e480b17",
  null
  
)

export default component.exports